import { useLocation } from "react-router-dom";
import HotelsRiverOpsContactWidget from "../opsContact/HotelsRiverOpsContactWidget";
import { parseLocaleFromPathname } from "../../utils/localeUrl";
import { isTripMasterSurface } from "../../surfaces/tripMaster/tripMasterEnv";

// The public agent site lives under /vacation-packages (and /agent/) with an optional
// locale prefix (/he, /en, /el, /us) that stays in location.pathname — there is no
// router basename — so we must strip it before matching. A ?siteId=<token> query is
// also a definitive public-site signal. On the public agent site only the agency
// lead widget (.public-lead-widget*) is allowed, never the HotelsRiver Ops contact.
function isPublicAgentSitePath(pathname, search) {
  const params = new URLSearchParams(search || "");
  const siteId = String(params.get("siteId") || "").trim();
  if (siteId) return true;

  const { pathnameWithoutLocale } = parseLocaleFromPathname(pathname || "");
  const path = pathnameWithoutLocale || "";
  return (
    path === "/vacation-packages" ||
    path.startsWith("/vacation-packages/") ||
    path === "/vacation_packages" ||
    path.startsWith("/vacation_packages/") ||
    path.startsWith("/agent/")
  );
}

// Internal work surfaces where a customer-facing contact widget would create junk
// Ops threads, plus the full-page public chat where a floating widget is redundant.
function isOpsContactExcludedPath(pathname) {
  const { pathnameWithoutLocale } = parseLocaleFromPathname(pathname || "");
  const path = pathnameWithoutLocale || "";
  return (
    path === "/dashboard" ||
    path.startsWith("/dashboard/") ||
    path === "/administration" ||
    path.startsWith("/administration/") ||
    path === "/p/dashboard" ||
    path.startsWith("/p/dashboard/") ||
    path === "/customer-chat" ||
    path.startsWith("/customer-chat/")
  );
}

/**
 * Site-wide HotelsRiver contact gate — replaces the AI vacation chat widget
 * with a direct Ops contact form. Visibility mirrors the old chat rules:
 * shown across HotelsRiver / Business, never on public agent sites.
 */
export default function HotelsRiverChatGate() {
  const location = useLocation();

  if (isTripMasterSurface()) return null;
  if (isPublicAgentSitePath(location.pathname, location.search)) return null;
  if (isOpsContactExcludedPath(location.pathname)) return null;

  const contactEnabled =
    typeof window === "undefined" ||
    window.__HR_PUBLIC_SITE_CHAT_ENABLED !== false;
  if (!contactEnabled) return null;

  return <HotelsRiverOpsContactWidget />;
}
